import * as React from "react";
import { tokens } from "@fluentui/react-components";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import { CopyButton } from "./CopyButton";
import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
    container: {
        position: "relative",
        borderRadius: "8px",
        overflow: "hidden",
        border: `1px solid ${tokens.colorNeutralStroke1}`,
    },
    copyButton: {
        position: "absolute",
        top: "8px",
        right: "8px",
        zIndex: 1,
        backgroundColor: tokens.colorNeutralBackground1,
        borderRadius: "6px",
        padding: "2px",
    },
});

export const CodeBlock: React.FC<{
    code: string;
    language?: string;
}> = ({ code, language = "tsx" }) => {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <div className={styles.copyButton}>
                <CopyButton value={code} title="Copy to clipboard" />
            </div>
            <SyntaxHighlighter
                language={language}
                style={vscDarkPlus}
                customStyle={{ margin: 0, padding: "1rem" }}
            >
                {code}
            </SyntaxHighlighter>
        </div>
    );
};
